import { motion } from 'framer-motion';
import styled from 'styled-components';

import { tokens as sheetTokens } from '@pkg/components/Sheet/tokens';
import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledMedia,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './LocalCurrencySelector.tokens';

export const StyledLocalCurrencySelector = styled.div`
    --local-currency-selector-bg-color: rgb(255, 255, 255, 0.06);
    --local-currency-selector-bg-color-hover: rgb(255, 255, 255, 0.1);
`;

export const Action = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};

    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${tokens.padding / 2}px;
    padding-left: ${tokens.padding}px;
    padding-right: ${tokens.padding}px;
    width: 100%;
    min-width: ${tokens.minWidth}px;
    height: ${tokens.height}px;
    text-align: left;
    border-radius: 999px;
    background-color: var(--local-currency-selector-bg-color);
    outline: 2px solid transparent !important;
    outline-offset: 2px;
    transition-property: opacity, background-color, outline-color;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &[aria-controls] {
        --local-currency-selector-bg-color: ${designColor.brandPurple};
        --local-currency-selector-bg-color-hover: ${designColor.brandPurpleLight};
    }

    &[disabled] {
        ${styledInteraction.interactionDisable};
        opacity: 0.8;
    }

    &:focus-visible {
        outline-color: ${designColor.brandPurple} !important;
    }

    &:hover:not(:active) {
        background-color: var(--local-currency-selector-bg-color-hover);
    }
`;

export const Name = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.fontSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export const ArrowWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.iconSize}px;
    height: ${tokens.iconSize}px;
`;

export const MenuPopover = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    // TODO: This z-index should not be necessary once we eliminate it
    // from <Sheet />... until then, we need to stay one above Sheet.
    z-index: ${sheetTokens.zindex.temp + 1};
    width: max-content;
`;
